import React, { useState } from 'react'
import styled from 'styled-components'

import { LabelType } from '../../../utils/LabelUtils'
import { ProductImageListModal } from '../ProductImageListModal'
import { ProductCarousel } from '../ProductCarousel'

export const ProductImage = ({
  imageIndex,
  labels,
}: {
  imageIndex?: number
  labels?: LabelType[]
}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(
    null
  )
  return (
    <Container>
      <CarouselWrapper>
        <ProductCarousel
          initialSlide={imageIndex}
          onSlideClick={(index: number) => {
            setSelectedImageIndex(index)
          }}
          imageIndex={imageIndex}
        />
      </CarouselWrapper>

      {selectedImageIndex !== null && (
        <ProductImageListModal
          hide={() => setSelectedImageIndex(null)}
          selectedImageIndex={selectedImageIndex}
        />
      )}

      {labels?.map((label, i) => {
        if (label.isIcon) {
          return (
            <LabelIcon
              style={{ ...label.appearance, ...label.location }}
              key={label._id}
              src={label.icon}
            />
          )
        }
      })}
    </Container>
  )
}

const LabelIcon = styled.img`
  background-color: transparent !important;
  position: absolute;
  z-index: 1;
`
const Container = styled.div.attrs({
  className: 'pb-3',
})`
  position: relative;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    max-width: 100%;
    width: 100%;
    margin: 0;
  }

  & img {
    background: #f3f3f3;
  }
`
const CarouselWrapper = styled.div`
  max-width: 100vw;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    max-width: 100%;
  }
`
